<template>
  <div 
    v-if="column.type==='action'"
    class="action-cell"
  >
    <template v-for="btn in (column.actionList || scope.row[column.key] || [])">
      <el-button 
        v-if="!hiddenBtn(btn, scope.row)"
        :key="btn.key"
        type="text"
        :class="['table-btn', btn.type || 'default']" 
        size="mini"
        :disabled="disabledBtn(btn, scope.row)"
        @click="handleClick('actionClick', btn, scope.row)" 
      >
        <i 
          v-if="btn.icon"
          :class="'el-icon-' + btn.icon" 
        />
        {{ btn.name }}
      </el-button>
    </template>
    <el-button 
      v-if="!(column.actionList || scope.row[column.key] || []).length"
      type="text" 
      size="small"
    >
      —
    </el-button>
  </div>
  <div v-else-if="column.type==='label'">
    <template v-if="isArray(scope.row[column.key])"> 
      <div 
        v-for="(item, index) in scope.row[column.key]"
        :key="index"
        class="label-item"
      >
        <template v-if="column.labelList && column.labelList.length">
          <div>
            <span 
              v-for="label in column.labelList"
              :key="label.key"
              class="label-item-inline"
            >
              <label>{{ label.name }}：</label>
              <span>{{ item[label.key] }}；</span>
            </span>
          </div>
        </template>
        <template v-else>
          <label>{{ item[column.labelKey || 'label'] }}:</label>
          <span>{{ item[column.valueKey || 'value'] }}</span>
        </template>
      </div>
    </template>
    <template v-else>
      <div 
        v-for="label in column.labelList"
        :key="label.key"
        class="label-item"
      >
        <label>{{ label.name }}:</label>
        <span>{{ getLabelText(column, scope.row, label) }}</span>
      </div>
    </template>
  </div>
  <div v-else-if="column.type==='tag'">
    <template v-for="tag in column.tagList">
      <el-tag
        v-if="checkValue(scope.row[tag.key])"
        :key="tag.key"
        :color="getTagColor(tag, scope.row)"
        class="tag-item"
        effect="dark"
        :hit="false"
      >
        {{ getText(tag, scope.row) }}
      </el-tag>
    </template>
  </div>
  <el-switch
    v-else-if="column.type==='switch'"
    :value="scope.row[column.key]"
    :active-value="column.activeValue"
    :inactive-value="column.inactiveValue"
    :disable="column.disabledKey && scope.row[column.disabledKey]"
    @change="handleClick('switch', column, scope.row, ...arguments)"
  />
  <span
    v-else-if="column.type==='colored-text'"
    :style="{
      color: column.getColor ? column.getColor(scope.row) : '#303133'
    }"
  >
    {{ scope.row[column.key] }}
  </span>
  <el-button
    v-else-if="column.type==='link'"
    type="text"
    @click="handleClick('linkClick', column, scope.row)"
  >
    {{ scope.row[column.key] || column.linkText }}
  </el-button>
  <el-image
    v-else-if="column.type==='image'"
    style="width: 100px; height: 100px"
    :src="scope.row[column.key]"
    :preview-src-list="[scope.row[column.key]]"
    fit="fill"
  />
  <div
    v-else-if="column.type==='links'"
    class="link-box"
  >
    <template v-if="isArray(scope.row[column.key]) ? !!scope.row[column.key].length : !!scope.row[column.key]">
      <el-button
        v-for="link in column.linkList"
        :key="link.key"
        type="text" 
        size="small"
        @click="handleClick('linkClick', link, scope.row)"
      >
        {{ column.linkTextFormat ? column.linkTextFormat(link, scope.row) : (scope.row[link.key] || link.linkText) }}
      </el-button>
    </template>
  </div>
  <span v-else>{{ checkValue(scope.row[column.key]) && column.options ? column.options[scope.row[column.key]] : scope.row[column.key] }}{{ column.unit }}</span>
</template>

<script>
import { isArray, isObject } from '@/common/utils';
export default {
  props: {
    column: {
      required: true,
    },
    scope: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    hiddenBtn(btn, row) {
      if (btn.hidden && typeof btn.hidden === 'function') {
        return btn.hidden(row);
      }
      return btn.hidden;
    },
    disabledBtn(btn, row) {
      if (btn.disabled && typeof btn.disabled === 'function') {
        return btn.disabled(row);
      }
      return btn.disabled;
    },
    handleClick() {
      this.$emit('handleClick', ...arguments);
    },
    isArray(arr) {
      return isArray(arr);
    },
    checkValue(val) {
      if (isArray(val)) return val.length;
      return val || val === 0;
    },
    getLabelText(col, row, label) {
      let colKey = col.key;
      let val = row[colKey] ? row[colKey][label.key] : row[label.key];
      if (label.options) {
        return label.options[val];
      }
      return val;
    },
    getText(col, row) {
      if (this.checkValue(row[col.key]) && col.options) {
        let o = col.options[row[col.key]];
        if (isObject(o)) return o.label;
        return col.options[row[col.key]];
      }
      return row[col.key];
    },
    getTagColor(tag, row) {
      if (tag.options) {
        let o = tag.options[row[tag.key]];
        if (o) return o.color;
      }
      return tag.color;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-cell {
  display: flex;
  justify-content: center;
  .table-btn {
    &.danger {
      color: #f5222d;
    }
  }
}
.link-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-button + .el-button {
    margin-left: 0;
  }
}
.label-item {
  display: flex;
  &.label-item-inline {
    > label {
      min-width: fit-content;
      color: #888;
    }
    > span {
      color: #444;
    }
  }
  > label {
    flex-shrink: 0;
    display: inline-block;
    margin-right: 5px;
    min-width: 30px;
    font-size: 12px;
    color: #888;
  }
  > span {
    font-size: 12px;
    color: #444;
  }
}
.tag-item {
  margin-left: 5px;
  &.el-tag {
    border: 1px solid rgba(1, 1, 1, 0) !important;
  }
}
</style>
